import React from "react";
import Image from "next/image";

export default function Logo({ size }) {
  return (
    <>
    <Image
        alt=""
        src="/images/logo2.png"
        layout="fixed"
        width="200"
        height="52"
        priority={true}
      />
    </>
  )
}